import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { environment } from '../../../environments/environment';

/**
 * Thin wrapper around a single socket.io WebSocket connection.
 * Features subscribe to typed events; the connection is lazy and shared.
 */
@Injectable({ providedIn: 'root' })
export class RealtimeService {
  private socket: Socket | null = null;

  private getSocket(): Socket {
    if (!this.socket) {
      this.socket = io(environment.wsUrl, {
        transports: ['websocket'],
        autoConnect: true,
      });
    }
    return this.socket;
  }

  /** Listen to a server event as an Observable. */
  on<T>(event: string): Observable<T> {
    const socket = this.getSocket();
    return new Observable<T>((subscriber) => {
      const handler = (payload: T) => subscriber.next(payload);
      socket.on(event, handler);
      return () => socket.off(event, handler);
    });
  }

  /** Emit an event to the server. */
  emit<T>(event: string, payload: T): void {
    this.getSocket().emit(event, payload);
  }

  disconnect(): void {
    this.socket?.disconnect();
    this.socket = null;
  }
}
